export default {
    text: 'Blogging',
    path: '/blogging',
    icon: 'blog.svg',
    children: [
        {
            text: 'Live Blogs',
            path: '/blogging/blogs',
            children: [],
            permissions: {
                CLIVEBLOG: 'READ'
            }
        },
        {
            text: 'Blog Icons',
            path: '/blogging/icons',
            children: [],
            permissions: {
                CLIVEBLOG: 'READ'
            }
        }
    ],
    permissions: {
        CLIVEBLOG: 'READ'
    }
};
